/**
 * Switch Canva Account Page
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Container, Paper, Button, Typography, Alert,
} from '@mui/material';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';

const API_BASE_URL = process.env.REACT_APP_API_URL || (
  window.location.hostname === 'localhost'
    ? 'http://localhost:8000/api'
    : `${window.location.protocol}//${window.location.host}/api`
);

export default function SwitchAccountPage() {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    // Open Canva logout in new tab so user can switch account, stay on this page
    window.open('https://www.canva.com/logout', '_blank', 'noopener,noreferrer');
  };

  const handleLoginWithCanva = () => {
    sessionStorage.setItem('canva_auth_pending', '1');
    window.location.href = `${API_BASE_URL}/auth/canva/authorize`;
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #424242 0%, #757575 50%, #D32F2F 100%)',
    }}>
      <Container maxWidth="sm">
        <Paper elevation={24} sx={{ p: 5, borderRadius: 2, textAlign: 'center' }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Access Denied
            </Typography>
          </Box>

          <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
            Your Canva account does not have access to this application.
            Only <strong>MAS Holdings enterprise Canva accounts</strong> are allowed.
          </Alert>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            To continue, sign out of your current Canva account and sign back in with your MAS Holdings work account.
          </Typography>

          <Button
            fullWidth
            variant="outlined"
            color="error"
            size="large"
            onClick={handleTryAgain}
            sx={{ mb: 2, textTransform: 'none', fontWeight: 600, py: 1.4 }}
          >
            Sign out of Canva (opens in new tab)
          </Button>

          <Button
            fullWidth
            variant="contained"
            size="large"
            startIcon={<SwitchAccountIcon />}
            onClick={handleLoginWithCanva}
            sx={{
              textTransform: 'none', fontWeight: 600, py: 1.4,
              background: 'linear-gradient(135deg, #D32F2F 0%, #B71C1C 100%)',
              '&:hover': { background: 'linear-gradient(135deg, #B71C1C 0%, #7f0000 100%)' },
            }}
          >
            Login with a different Canva account
          </Button>

          <Button
            variant="text"
            size="small"
            onClick={() => navigate('/login')}
            sx={{ mt: 2, textTransform: 'none', color: 'text.secondary' }}
          >
            ← Back to Login
          </Button>
        </Paper>

        <Typography variant="body2" align="center" sx={{ mt: 3, color: 'white', opacity: 0.9 }}>
          2026 MAS Holdings. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
